export default "__VITE_ASSET__r9bJsTBM__"